var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsKeyboardArrowDownRoundedUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:keyboard-arrow-down-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 11C16.1913 11 16.3769 11.0382 16.5568 11.1145C16.7366 11.1909 16.8859 11.2926 17.0045 11.4199L23.6054 18.4428C23.8685 18.7227 24 19.0789 24 19.5115C24 19.944 23.8685 20.3003 23.6054 20.5802C23.3423 20.8601 23.0075 21 22.6009 21C22.1943 21 21.8595 20.8601 21.5964 20.5802L16 14.626L10.4036 20.5802C10.1405 20.8601 9.80568 21 9.3991 21C8.99253 21 8.6577 20.8601 8.39462 20.5802C8.13154 20.3003 8 19.944 8 19.5115C8 19.0789 8.13154 18.7227 8.39462 18.4428L14.9955 11.4199C15.139 11.2672 15.2945 11.1588 15.4619 11.0947C15.6293 11.0306 15.8087 10.999 16 11Z",
    fill: "#4E0AA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsKeyboardArrowDownRoundedUpBlue);
export default __webpack_public_path__ + "static/media/material-symbols_keyboard-arrow-down-rounded_up_blue.dedc2098a500d659219ed7de25111e96.svg";
export { ForwardRef as ReactComponent };